import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { useAppDispatch } from 'src/app/hooks';
import { removeModal } from 'src/features/globalSlice';
import { routes } from 'src/routes';
import { DeviceError } from 'src/store/models/Device';
import { Modal } from 'src/store/models/Modal';

import ListError from '../DetectedErrors/ListError/ListError';
import classes from './ErrorsModal.module.scss';

export interface ErrorsModalProps {
  modal?: Modal;
}

const ErrorsModal: FC<ErrorsModalProps> = ({ modal }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  return (
    <div className={classes.Container}>
      <header>
        <h5>{modal?.title}</h5>
        <FontAwesomeIcon
          icon={faTimes}
          onClick={() => dispatch(removeModal())}
        />
      </header>
      <ul>
        {(modal?.data as DeviceError[])?.map((e, i) => (
          <li key={i}>
            <ListError
              error={e}
              onClick={() => {
                dispatch(removeModal());
                navigate(routes.ERROR_INDEX, { state: e });
              }}
            />
          </li>
        ))}
      </ul>
      <Link onClick={() => dispatch(removeModal())} to={routes.ERROR_INDEX}>
        {t('ticket_details:view_error_index')}
      </Link>
    </div>
  );
};

export default ErrorsModal;
